// Tier → coloured glow + badge used by Marketplace tiles, Merchant Detail
// header, and service item cards. Single source of truth for the plan
// tier visual language (Pro cyan / Elite gold).
export const TIER_STYLES = {
  pro:   { ring: 'ring-2 ring-[#00E5FF]', shadow: 'shadow-[0_0_18px_rgba(0,229,255,0.35)]', label: 'Pro',   labelBg: 'bg-[#00E5FF]/15 text-[#00E5FF] border-[#00E5FF]/40' },
  elite: { ring: 'ring-2 ring-[#FFD740]', shadow: 'shadow-[0_0_22px_rgba(255,215,64,0.55)]', label: 'Elite', labelBg: 'bg-[#FFD740]/15 text-[#FFD740] border-[#FFD740]/40' },
};
// Legacy keys kept so older data renders as Pro.
TIER_STYLES.basic = TIER_STYLES.pro;
TIER_STYLES.professional = TIER_STYLES.pro;

/** Map a plan name to the tier key. Only Pro and Elite are sold; legacy plans
 *  (Starter / Basic / Professional) display as Pro. */
export function tierKey(planName) {
  const s = (planName || '').trim().toLowerCase();
  if (!s) return null;
  if (s.includes('elite') || s.includes('premium')) return 'elite';
  return 'pro';
}

/** Display label for any plan name ("Professional" → "Pro"). */
export function tierLabel(planName) {
  const k = tierKey(planName);
  return k ? TIER_STYLES[k].label : '';
}

/** Convenience getter — returns `null` if the plan isn't a recognised tier. */
export function tierStyleFor(planName) {
  const key = tierKey(planName);
  return key ? TIER_STYLES[key] : null;
}
